import React from 'react'
import { View, StyleSheet } from 'react-native'
import ProductList from '../../components/ProductList'
import { useAtomValue } from 'jotai'
import { activeProductsByCategoryListAtom } from '../../global/AtomsProvider'

export default function AddProductStickerScreen( { navigation, route } ) {
  const activeProductsByCategoryList = useAtomValue(activeProductsByCategoryListAtom)
  const { addSticker } = route.params

  const onItemPress = (item, index, store) => {
    addSticker(item, index)
    navigation.goBack()
  }

  return (
    <View style={styles.container}>
      <ProductList products={activeProductsByCategoryList} onItemPress={onItemPress} />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'stretch',
  }, 
});
